import type { ReactNode } from "react"
import { toast as sonnerToast, type ExternalToast } from "sonner"

type ToastInput = ExternalToast & {
  title?: ReactNode
  variant?: "default" | "destructive"
}

export const HAWK_TOAST_TEST_ID_PREFIX = "hawk-toast-"

let toastCount = 0

function nextToastId() {
  toastCount = (toastCount + 1) % Number.MAX_SAFE_INTEGER
  return String(toastCount)
}

function showToast(props: ToastInput, id: string | number) {
  const { title, description, variant = "default", ...options } = props
  const message = title ?? description ?? "Notification"
  const resolvedDescription = title ? description : undefined
  const toastOptions: ExternalToast = {
    ...options,
    id,
    testId: `${HAWK_TOAST_TEST_ID_PREFIX}${id}`,
    closeButton: true,
    description: resolvedDescription,
    duration: options.duration ?? 6000,
  }

  return variant === "destructive"
    ? sonnerToast.error(message, toastOptions)
    : sonnerToast(message, toastOptions)
}

function toast(props: ToastInput) {
  const id = nextToastId()
  showToast(props, id)

  return {
    id,
    dismiss: () => sonnerToast.dismiss(id),
    update: (nextProps: ToastInput) => showToast({ ...props, ...nextProps }, id),
  }
}

function useToast() {
  return {
    toast,
    dismiss: (toastId?: string | number) => sonnerToast.dismiss(toastId),
  }
}

export { useToast, toast }
